import { Component, Input } from "@angular/core";

@Component({
    selector: 'app-checkmark',
    styleUrls: ['checkmark.component.scss'],
    templateUrl: 'checkmark.component.html'
})
export class CheckmarkComponent
{
    @Input() public completed = false;

    public constructor()
    {
        
    }

    public setCompleted(state: boolean)
    {
        this.completed = state;
    }
}
